import React from 'react';
import { BottomSheet } from '../../../../../app/common/sharedComponents/BottomSheet';
import { CompSetSelector } from '../../../../../app/dashboard/components/CompSetSelector';
import { getItem } from '../../../../../utils/localStorage';

interface ICompset {
  compSetName: string;
  compSetNumber: number;
}

interface ICompsetByHotel {
  hotelId: string;
  selectedCompset: number;
}

interface ICompsetSelectorPortalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedHotel: string;
  lqaCompset?: ICompset[];
  setSelectedCompset: (compset: number) => void;
  setCompsetOpen: (isOpen: boolean) => void;
}

function CompsetSelectorPortal ({
  isOpen,
  onClose,
  selectedHotel,
  lqaCompset,
  setSelectedCompset,
  setCompsetOpen,
}: ICompsetSelectorPortalProps) {
  const selectedCompsetbyHotel: ICompsetByHotel[] =
    getItem('selectedCompsetbyHotel') || [];
  const foundItem = selectedCompsetbyHotel.find(
    (item) => item.hotelId === selectedHotel
  );
  const selectedItem = foundItem && foundItem.selectedCompset;

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose}>
      <CompSetSelector
        selectedHotel={selectedHotel}
        compSetList={lqaCompset}
        setSelectedCompset={setSelectedCompset}
        setCompsetOpen={setCompsetOpen}
        selectedItem={selectedItem}
      />
    </BottomSheet>
  );
}

export { CompsetSelectorPortal };
